<div *ngIf="isLoading"
  class="fixed top-4 right-4 z-50 bg-white dark:bg-dark-panel rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-3 flex items-center space-x-3 backdrop-blur-sm bg-opacity-95 dark:bg-opacity-95 transition-all duration-300 ease-in-out animate-fade-in">


  <div class="relative">
    <div [ngClass]="loaderSize" class="animate-spin">
      <svg class="w-full h-full text-blue-500" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-dasharray="31.416" stroke-dashoffset="31.416" class="animate-dash">
        </circle>
      </svg>
    </div>

    <div [ngClass]="loaderSize" class="absolute inset-0 animate-ping bg-blue-400 rounded-full opacity-20"></div>
  </div>


  <div class="flex flex-col">
    <span [ngClass]="messageSize" class="font-medium text-gray-700 dark:text-gray-200">{{ message }}</span>
    <div class="flex space-x-1 mt-1">
      <div class="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 0ms"></div>
      <div class="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 150ms"></div>
      <div class="w-1 h-1 bg-blue-500 rounded-full animate-bounce" style="animation-delay: 300ms"></div>
    </div>
  </div>
</div>
